export const developmentBundleId = '00000000-0000-0000-0000-000000000000'

/**
 * A stale bundle reloads only when navigation leaves the current area, so that changing tabs on a table stays smooth.
 *
 * e.g.
 * ✅ from "/requests/[tab]" to "/workflows"
 * ❌ from "/renewals/pending" to "/renewals/completed"
 *
 * The supplier portal is a single top-level path that a supplier never leaves, so each portal page is its own area;
 * otherwise a portal tab keeps its stale bundle until the supplier refreshes by hand.
 */
export const isNavigationToNewArea = (currentUrl: string, nextUrl: string) => getArea(currentUrl) !== getArea(nextUrl)

const getArea = (url: string) => {
  const [pathname = ''] = url.split(/[?#]/)
  const topLevelPath = pathname.split('/')[1] || ''
  return topLevelPath === 'supplier-onboarding' ? pathname : topLevelPath
}
